import { useEffect } from "react";
import { useMap } from "react-map-gl/mapbox";
import { useMapContext } from "../contexts/MapContext";
import { useBreakpointValue } from "@gemini/core";
export const useResizeViewport = () => {
    const isMobile = useBreakpointValue({
        base: true,
        md: false,
    });
    const { current: map } = useMap();
    const { isSidebarOpen } = useMapContext();
    useEffect(() => {
        if (map) {
            map.resize();
        }
    }, [map, isSidebarOpen, isMobile]);
};
